const keysOfReleaseListItem = ["id", "name", "upcCode", "state", "globalState", "creationTime", "lastUpdateTime", "releaseTargetDate", "releaseDate", "hasCoverArt", "hasCoverSong", "countOfTracks", "isPublic"];

export { keysOfReleaseListItem };
